import { useAuth } from 'util/auth'
import { ModalV2 } from './Common/ModalV2'
import { Button } from './Button'
import { useProjectStore } from 'store/useProjectStore'
import { useEffect } from 'react'
import { ImageWithLoading } from './TrialRequired'

export const TrialStartedModal = () => {
  const { showTrialStartedModal, setShowTrialStartedModal, setShowConfetti } =
    useProjectStore()
  const auth = useAuth()

  useEffect(() => {
    setShowConfetti(true)
  }, [])

  if (!auth.user || !auth.user.hasStartedTrial) return null

  return (
    <>
      <ModalV2
        open={showTrialStartedModal}
        onClose={() => setShowTrialStartedModal(false)}
        className="!z-50 flex max-h-[500px] w-screen md:max-w-lg"
        includePadding={false}
      >
        <div className="flex">
          <div className="hidden h-full flex-1 md:block">
            <ImageWithLoading
              src="/trial-started.png"
              className="max-h-[500px] rounded-l-lg object-cover"
              alt="Outcast Logo"
            />
          </div>
          <div className="flex flex-1 flex-col justify-center px-8 py-4">
            <h1 className="mb-2 whitespace-nowrap text-xl font-bold">
              Free Trial Started!
            </h1>
            <p className="prose text-sm text-slate-500">
              <span className="text-sm font-bold text-slate-500">
                {
                  "We've added 60 minutes of uploads to your account to get you started."
                }
              </span>
            </p>

            <Button
              className="mt-8 w-full"
              onClick={() => setShowTrialStartedModal(false)}
            >
              Access Content!
            </Button>
            <p className="mt-2 text-xs text-slate-500">
              * Cancel anytime in your account settings.
            </p>
          </div>
        </div>
      </ModalV2>
    </>
  )
}
